<template>
  <div>
    <v-row wrap>
      <v-col cols="12" mr-4 :class="$vuetify.display.smAndUp ? 'ml-4' : ''">
        <div class="divMaxWidth">
          <v-row wrap class="text-center">
            <v-col cols="12" class="font-size--16 font-weight-bold mb-4 mt-4">
              <v-icon color="success" :icon="successicon" />
              {{ $t('L_success') }}
            </v-col>
            <v-col cols="12" font-size--16 mb-4>
              <span>{{ $t('L_bank_account_has_been_updated') }} </span>
              <span>{{ getPolicyId }}.</span>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-row wrap class="text-left">
                  <v-col cols="12">
                    <div class="centerWithMaxWidth">
                      <v-row wrap ml-4 mr-4 text-left>
                        <v-col cols="12" class="font-size--16 font-weight-bold my-0 py-0 mt-4">
                          {{ $t('L_here_are_the_details_for_your_bank_account_update') }}
                        </v-col>
                        <v-col cols="12" class="font-size--14 mt-4 py-0 my-0">
                          {{ $t('L_bank_account') }}
                        </v-col>
                        <v-col cols="12" class="font-size--16 font-weight-bold py-0 my-0">
                          {{ getMaskedAccountNumber }} {{ bankInfo.accountTypeString }}
                        </v-col>
                        <v-col cols="12" class="font-size--14 mb-4 py-0 my-0">
                          {{ bankInfo.bankName }}
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" class="font-size--16 mt-4 mb-4">
              <span>{{ $t('Bank_Account_L_an_email_confirmation_has_also_been_sent_to') }}</span>
              <span class="font-weight-bold">{{ userEmail }}.</span>
            </v-col>
            <v-col cols="12" mb-4 class="text-center maxButtonWidth mx-auto">
              <OnexButton id="update_bank_data" class="mb-3" @click="done" block size="large">
                {{ $t('L_done') }}
              </OnexButton>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { mapState, mapActions } from 'pinia';
import { filters } from '@/mixins/filters';
import { useGlobalStore } from '@/stores/global/global.store';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { mdiCheckCircle } from '@mdi/js';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'BankAccountTypeChangeStepThree',
  components: {
    OnexButton,
  },
  mixins: [filters],
  props: {
    bankInfo: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      mdiCheckCircle,
    };
  },
  computed: {
    ...mapState(useCustomerStore, ['customerProfile']),
    ...mapState(useGlobalStore, {
      dateFormat: 'getDateFormat',
    }),
    ...mapState(usePolicyStore, {
      policy: 'currentPolicy',
      bankName: 'bankName',
    }),
    getPolicyId() {
      return this.policy?.contractId || '';
    },
    getMaskedAccountNumber() {
      const value = this.bankInfo?.accountNumber || '';
      return `${value.substring(0, value.length - 4).replace(/\d/g, '')}****${value.substring(
        value.length - 4
      )}`;
    },
    userEmail() {
      return this.customerProfile?.email || this.policy?.owner?.email;
    },
    successicon() {
      return mdiCheckCircle;
    },
  },
  methods: {
    ...mapActions(useGlobalStore, {
      removeAlerts: 'removeAlerts',
    }),
    clearBank() {
      this.bankName = null;
    },
    done() {
      this.$emit('done');
      this.clearBank();
      // clear out the alerts here
      this.removeAlerts('payment');
    },
  },
};
export default defineComponent(componentOptions);
</script>

<style scoped lang="scss">
.divMaxWidth {
  max-width: 600px;
  margin: 0 auto;
}
.centerWithMaxWidth {
  max-width: 295px;
  margin: auto;
}
.maxButtonWidth {
  max-width: 295px !important;
  width: 295px;
  font-size: 16px;
}
.grey-ada-text {
  color: #737171;
}
.disclaimer-wrapper {
  overflow-y: scroll;
  max-height: 263px;
  min-height: 250px;
  border-radius: 2px;
  border: solid 1px #979797;
  padding: 20px;
}
.card-ach-wrapper {
  position: relative;
}
.fixed-top-sm-message-banner {
  position: absolute;
  top: -5px;
  left: 0;
  width: 100%;
  z-index: 1;
}
</style>
